import React, { useState, useEffect } from 'react';
import "./Visitor.css";
import qrImage from "../../Assets/Images/icon/wifiScan1.svg";
import { DESKIE_API as API } from '../../config';
import logo from "../../Assets/Images/logo/logo.svg";
import { Dropdown } from 'react-bootstrap';
import arrow from "../../Assets/Images/icon/downIcon.svg";
import { v4 as uuidv4 } from 'uuid';
import { visitorAdd } from '../../api/visitor';
import { showNotifications, TOAST_TYPE } from '../../CommonFunction/toaster';
import checkIcon from "../../Assets/Images/icon/check-circle1.svg"
import { getMemberList } from '../../api/member';
import { adminList } from '../../api/admin';
import { singleProfile } from '../../api/settings';
import { log } from 'console';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faSearch } from '@fortawesome/free-solid-svg-icons';

const Visitor = () => {
  const [profile, setProfile] = useState<any>();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [selectedItem, setSelectedItem] = useState<string | null>(null);
  const [roleItem, setRoleItem] = useState<string | null>(null);
  const [roleId, setRoleId] = useState<string | null>(null);
  const [visitorOption, setVisitorOption] = useState(true);
  const [visitorInfo, setVisitorInfo] = useState(false);
  const [successCheck, setSuccessCheck] = useState(false);
  const [member, setMember] = useState([]);
  const [admin, setAdmin] = useState([]);
  const [isActive, setIsActive] = useState(false);
  const [people, setPeople] = useState([]);
  const [reasonOpen, setReasonOpen] = useState(false);
  const [memberOpen, setMemberOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const screenWidth = window.innerWidth;
  const handleReasonToggle = (isOpen: any) => {
    setReasonOpen(isOpen);
  };
  useEffect(() => {
    const checkWidth = () => {
      if (window.innerWidth <= 800) {
        setVisitorInfo(true);
      }
    };

    // Initial check when component mounts
    checkWidth();

    // Add event listener to handle window resize
    window.addEventListener('resize', checkWidth);

    // Cleanup listener on unmount
    return () => {
      window.removeEventListener('resize', checkWidth);
    };
  }, []);

  const handleMemberToggle = (isOpen: any) => {
    setMemberOpen(isOpen);
  };

  const getSingleProfile = async () => {
    try {
      const data = await singleProfile();
      setProfile(data.data);
    } catch (err) {
      console.log(err);
    }
  }

  useEffect(() => {
    const fetchData = async () => {
      try {
        getSingleProfile(); // Assuming this doesn't affect member/admin

        const [memberData, adminData] = await Promise.all([
          getMemberList(100, 1),
          adminList()
        ]);

        const memberList = memberData.members;
        const adminListData = adminData;

        setMember(memberList);
        setAdmin(adminListData);

        const merged: any = [...adminListData, ...memberList].sort((a: any, b: any) => {
          const nameA = `${a.first_name} ${a.last_name}`.toUpperCase();
          const nameB = `${b.first_name} ${b.last_name}`.toUpperCase();
          return nameA.localeCompare(nameB);
        });

        setPeople(merged);

      } catch (err) {
        console.error('Error fetching member/admin:', err);
      }
    };

    fetchData();
  }, []);



  const handleSelect = (eventKey: string | null) => {
    setSelectedItem(eventKey);
  };

  const handleRoleSelect = (eventKey: string | null) => {
    const [id, name]: any = eventKey?.split('|');
    setRoleItem(name);
    setRoleId(id);
  };

  const manuallyOption = () => {
    setVisitorOption(false);
    setVisitorInfo(true);
  }

  const saveVisitor = () => {
    let invoiceInfo = {
      "id": uuidv4(),
      "name": name,
      "email": email,
      "reason": selectedItem,
      "looking": roleId,
      "companyName": profile.company_name,
      "address": profile.address,
      "logoImage": `${API}/${encodeURI(profile.company_logo_dark)}`,
    }

    visitorAdd(invoiceInfo).then((data) => {
      showNotifications(TOAST_TYPE.success, data.message);
      setVisitorInfo(false);
      setSuccessCheck(true);
      setTimeout(() => {
        finishVisitors();
      }, 10000);
    }).catch(() => {
      showNotifications(TOAST_TYPE.error, "Insert all the information");
    })
  }

  const finishVisitors = () => {
    setVisitorOption(true);
    setVisitorInfo(false);
    setSuccessCheck(false);
    setSelectedItem("");
    setRoleId("");
    setRoleItem("");
  }

  const filteredPeople = people.filter((person: any) =>
    `${person.first_name} ${person.last_name}`
      .toLowerCase()
      .includes(searchTerm.toLowerCase())
  );

  return (
    <section className='visitorSection' style={{
      background: screenWidth <= 800
        ? `linear-gradient(rgba(31, 41, 55, 0.9), rgba(31, 41, 55, 0.94)), url(${profile && `${API}/${encodeURI(profile.background)}`})`
        : 'none', // or a different background for wider screens
    }}>
      <div className="visitorLeft">
        <div className='visitorImage' style={{ background: `linear-gradient(rgba(31, 41, 55, 0.9), rgba(31, 41, 55, 0.94)), url(${profile && `${API}/${encodeURI(profile.background)}`})` }}>
          <div>
            {profile && profile.company_logo_dark ?
              <img src={`${API}/${profile.company_logo_dark}`} alt="logo" style={{ maxWidth: '280px', maxHeight: '75px' }} />
              : <img src={logo} alt="logo" />
            }
            <h5 className='mt-3'>Visitor Check-in</h5>
          </div>

        </div>
      </div>

      {visitorOption ? <div className="visitorRight visitorQr">
        <h5 className='mb-4'>Scan QR code to check-in as a guest</h5>
        <img src={qrImage} alt="qrImage" />
        <div className="orLine">
          <h2><span>or</span></h2>
        </div>
        <button className='tapNext' onClick={manuallyOption}>Tap to Check in Manually</button>
      </div> : ""}
      <div className='mobileVisitorHeading'>
        {profile && profile.company_logo_dark ?
          <img src={`${API}/${profile.company_logo_dark}`} alt="logo" style={{ maxWidth: '280px', maxHeight: '75px' }} />
          : <img src={logo} alt="logo" />
        }
        <h5 className='mt-3'>Visitor Check-in</h5>
      </div>
      {visitorInfo ? <div className="visitorRight">
        <div className="reasonVisit memberInput">
          <label className='mt-4'>Name</label>
          <input type="text" onChange={(e) => setName(e.target.value)} placeholder='Enter your name' className='form-control' required />
        </div>
        <div className="reasonVisit memberInput">
          <label className='mt-4'>Email</label>
          <input type="email" onChange={(e) => setEmail(e.target.value)} placeholder='Enter your E-mail' className='form-control' required />
        </div>
        <div className="reasonVisit memberInput">
          <label className='mt-4'>Reason For Visit</label>
          <Dropdown onToggle={handleReasonToggle} onSelect={handleSelect} className='dropdown-menu-margin visitor-dropdown' >
            <Dropdown.Toggle id="dropdown-basic" className={reasonOpen ? 'visitor-dropdown' : ''} >
              {selectedItem && selectedItem ? <>{selectedItem} <img src={arrow} alt="arrow" /></> : <div className='noneSelect d-flex w-100'>Select a reason <img src={arrow} alt="arrow" /></div>}
            </Dropdown.Toggle>

            <Dropdown.Menu className='visitor-dropdown-edge'>
              <div style={{ maxHeight: '230px', overflowY: 'auto' }}>
                <Dropdown.Item className='dropDown-focus' eventKey="Guest">Guest</Dropdown.Item>
                <Dropdown.Item className='dropDown-focus' eventKey="Delivery">Delivery</Dropdown.Item>
                <Dropdown.Item className='dropDown-focus' eventKey="Maintenance">Maintenance</Dropdown.Item>
                <Dropdown.Item className='dropDown-focus' eventKey="Tour">Tour</Dropdown.Item>
                <Dropdown.Item className='dropDown-focus' eventKey="Other">Other</Dropdown.Item>
              </div>
            </Dropdown.Menu>
          </Dropdown>
        </div>
        <div className="reasonVisit mb-2">
          <label className='mt-4'>I’m Here To See</label>
          <div className='memberInfos assignBox'>
            <div className='dropdown'>
              <div onClick={(e) => { setIsActive(!isActive); }} className='dropdown-btn'>
                <div className='d-flex tableImage'>
                  <div>
                    <p>{roleItem && roleItem ? roleItem : "Select a member"}</p>
                  </div>
                </div>
                <span>
                  <FontAwesomeIcon icon={faChevronDown} />
                </span>
              </div>
              <div className='dropdown-content' style={{ display: isActive ? "block" : "none", height: '302px' }} >
                <div className='assignInput px-2'>
                  <FontAwesomeIcon icon={faSearch} />
                  <input type='text' placeholder='Search member' className='form-control' value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} />
                </div>
                <div className='member-container'>
                  {filteredPeople.map((data: any, index) => (
                    <div
                      key={`assignSpace` + index}
                      onClick={(e) => {
                        setIsActive(!isActive);
                        handleRoleSelect(`${data.id}|${data.first_name} ${data.last_name}`);
                      }}
                      className='item tableImage'
                    >
                      {data.first_name} {data.last_name}

                    </div>))}
                </div>
              </div>
            </div>
          </div>

          {/*  <Dropdown onToggle={handleMemberToggle} onSelect={handleRoleSelect} className='bg-white'>
            <Dropdown.Toggle id="dropdown-basic" className={memberOpen ? 'visitor-dropdown' : ''}>
              {roleItem && roleItem ? <>{roleItem} <img src={arrow} alt="arrow" /></> : <div className='noneSelect d-flex w-100'>Select a member <img src={arrow} alt="arrow" /></div>}
            </Dropdown.Toggle>
            <Dropdown.Menu className='visitor-dropdown-edge'>
              <div style={{ maxHeight: '120px', overflowY: 'auto' }}>
                {people && people.map((people: any, index: number) => <Dropdown.Item className='dropDown-focus' eventKey={`${people.id}|${people.first_name} ${people.last_name}`}>{people.first_name} {people.last_name}</Dropdown.Item>)}
              </div>
            </Dropdown.Menu>
          </Dropdown> */}
        </div>
        <button className='tapNext mt-4 callBack' onClick={saveVisitor}>Submit</button>
      </div> : ""}

      {successCheck ? <div className="visitorRight">
        <div className="success text-center">
          <img className='mb-4' src={checkIcon} alt="check" />
          <h5>Welcome, {name}!</h5>
          <h4>{roleItem} has been notified that you’re here.</h4>
          <button onClick={finishVisitors} className="callBack w-100">Done</button>
        </div>
      </div> : ""}

    </section>
  )
}

export default Visitor